module.exports = __webpack_public_path__ + "img/logo-watermark.ead6ec1a.png";